import { render, staticRenderFns } from "./ybbj.vue?vue&type=template&id=3ac474b9&scoped=true&"
import script from "./ybbj.vue?vue&type=script&lang=js&"
export * from "./ybbj.vue?vue&type=script&lang=js&"
import style0 from "./ybbj.vue?vue&type=style&index=0&id=3ac474b9&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ac474b9",
  null
  
)

export default component.exports